<template>
  <v-dialog
    ref="dialog"
    v-model="dialog"
    :return-value.sync="time"
    light
  >
    <template #activator="{ on, attrs }">
      <v-badge
        dot
        color="primary"
        offset-x="44"
        offset-y="14"
        :value="badge"
      >
        <v-btn
          v-on="on"
          v-bind="attrs"
          icon
          :disabled="loading"
        >
          <v-icon v-text="icons[icon ?? filter]" />
        </v-btn>
      </v-badge>
    </template>
    <v-card>
      <v-toolbar
        flat
        dense
        color="grey lighten-4"
      >
        <v-icon left v-text="icons[icon ?? filter]" />
        <v-toolbar-title class="text-h6">
          {{ __(title ?? filter) }}{{ time ? ` ${time}h.` : '…' }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          color="primary"
          @click="dialog = false"
        >
          <v-icon v-text="icons.close" />
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text class="px-0 pt-4 d-flex justify-center">
        <v-time-picker
          v-if="dialog"
          v-model="time"
          format="24hr"
          no-title
          color="primary"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-text="__('cancel')"
          text
          color="grey darken-1"
          @click="cancel()"
        />
        <v-spacer />
        <v-btn
          v-text="__('done')"
          text
          color="primary"
          @click="save()"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    props: {
      filter: {
        required: true,
        type: String,
      },
      icon: {
        type: String,
      },
      title: {
        type: String,
      },
    },

    data: () => ({
      dialog: false,
    }),

    computed: {
      ...mapState('history', [
        'loading',
        'filters',
      ]),
      time: {
        get () {
          return this.filters[this.filter]?.time
        },
        set (v) {
          this.$store.commit('history/filter', {
            key: this.filter,
            time: v,
          })
        },
      },
      badge () {
        return !! this.time
      },
    },

    methods: {
      cancel () {
        this.time = null
        this.save()
      },
      save () {
        this.$refs.dialog.save(this.time)
      },
    },
  }
</script>
